import { Flex, Space, Spacing } from '@billy/design-system'
import cc from 'classcat'
import React, { useState } from 'react'

import { reactClass } from '../../utils'
import { ActionGroup, ActionGroupItem } from '../ActionGroup'
import { TabContentProps } from './TabContent'

export type TabsProps = {
  children: React.ReactNode
  className?: string
  onSelectAction?: (value: string) => void
}

export const Tabs = ({ children, className, onSelectAction }: TabsProps) => {
  let pick = ''

  React.Children.forEach(children, (child: any) => {
    const { selected, fixed, id, text } = child.props
    if (!fixed && !pick) {
      pick = id || text
    }
    if (!fixed && selected) {
      pick = id || text
    }
  })

  const [selected, setSelected] = useState<string>(pick)

  const handleSelectAction = (value: string) => {
    setSelected(value)
    if (onSelectAction) {
      onSelectAction(value)
    }
  }

  return (
    <div className={cc([className, reactClass('tabs')])}>
      <ActionGroup onSelectAction={handleSelectAction}>
        {React.Children.map(
          children as React.ReactElement<TabContentProps>[],
          (child: React.ReactElement<TabContentProps>): JSX.Element | null =>
            React.isValidElement(child) && !child.props.fixed ? (
              <ActionGroupItem
                value={child.props.id || (child.props.text as string)}
                selected={child.props.id === selected || child.props.text === selected}
              >
                {child.props.text}
              </ActionGroupItem>
            ) : null,
        )}
      </ActionGroup>
      <Space />
      <Flex gap={Spacing.S24} width="100%" justifyContent="space-between">
        {React.Children.map(
          children as React.ReactElement<TabContentProps>[],
          (child: React.ReactElement<TabContentProps>): JSX.Element | null =>
            React.isValidElement(child) &&
            (child.props.fixed || child.props.id === selected || child.props.text === selected)
              ? React.cloneElement(child, {
                  className: 'tabs-content',
                  selected: child.props.id === selected,
                  style: { flex: 1 },
                })
              : null,
        )}
      </Flex>
    </div>
  )
}
